<template>
  <AppContainer is-loading />
</template>

<script setup>
import AppContainer from '@/components/AppContainer.vue'
import { useApiRequestHelper } from '@/composables/useApiRequestHelper'
import { useRedirectToError } from '@/composables/useRedirectToError'
import { useTranslationPath } from '@/composables/useTranslationPath.js'
import { useAppStore } from '@/stores/AppStore'
import { resetAllStores } from '@/stores/resetAllStores'
import { useUnauthenticatedTokenStore } from '@/stores/unauthenticated/UnauthenticatedTokenStore.js'
import { inject, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'

const { t } = useI18n()
const axios = inject('$axios')
const route = useRoute()
const router = useRouter()
const appStore = useAppStore()
const unauthenticatedTokenStore = useUnauthenticatedTokenStore()

const { apiUrlBase, setApiUrlUnauthenticated } = useApiRequestHelper()

const callerPath = 'views.unauthenticated.index'

onMounted(async () => {
  resetAllStores()

  const token = route.params.token
  const tokenId = route.query.token_id
  const apiUrl = route.query.api_url

  if (!apiUrl || !tokenId) {
    await useRedirectToError(router)
      .setTitle(t(useTranslationPath(callerPath, 'errorTitle')))
      .setMessage(t(useTranslationPath(callerPath, 'errorMessage')))
      .setStatus(400)
      .redirect()

    return
  }

  await appStore.$patch({
    apiUrl: apiUrl,
  })

  await unauthenticatedTokenStore.$patch({
    token: token,
    tokenId: tokenId,
  })

  await setApiUrlUnauthenticated()

  await appStore.$patch({
    bearerToken: null,
  })

  await axios
    .get(`${apiUrlBase.value}/bearer-token/${token}`)
    .then(async ({ data: { data } }) => {
      await appStore.$patch({
        bearerToken: data.token,
      })
    })
    .catch(async () => {
      await useRedirectToError(router).redirect()
    })

  await appStore.getConfigVarsUnauthenticated()

  await router.push({
    name: 'auth.welcome',
  })
})
</script>
